export {
    PENDING,
    CONFIRMED,
    FAILED
}

const PENDING = 0
const CONFIRMED = 1
const FAILED = 2